<sz-bottom-sheet [open]="open()" (close)="dismiss.emit()">
  <div szSheetHeader class="sz-date-picker__head">
    <div class="sz-date-picker__title">{{ headerLabel() }}</div>
    <div class="sz-date-picker__subtitle">{{ weekdayLabel() }}</div>
  </div>

  <div class="sz-date-picker__body">
    @if (step() === 'date') {
      <sz-calendar [value]="localDate()" [min]="min()" [max]="max()" (valueChange)="onDateSelect($event)" />

      @if (withTime()) {
        <label class="sz-date-picker__time-toggle">
          <span class="sz-date-picker__time-label">{{ 'common.datePicker.addTime' | translate }}</span>
          <sz-toggle
            [ngModel]="timeEnabled()"
            (ngModelChange)="onTimeToggle($event)"
            [ariaLabel]="'common.datePicker.addTime' | translate" />
        </label>
      }
    } @else {
      <sz-time-wheel [value]="localTime()" (valueChange)="onTimeChange($event)" />
    }
  </div>

  <div szSheetCta class="sz-date-picker__cta">
    @if (step() === 'date') {
      <sz-button variant="ghost" (click)="selectToday()">
        {{ 'common.datePicker.today' | translate }}
      </sz-button>
      @if (timeEnabled()) {
        <sz-button variant="primary" [fullWidth]="true" (click)="goToTimeStep()">
          {{ 'common.datePicker.next' | translate }}
        </sz-button>
      } @else {
        <sz-button variant="primary" [fullWidth]="true" (click)="done()">
          {{ 'common.datePicker.done' | translate }}
        </sz-button>
      }
    } @else {
      <sz-button variant="ghost" (click)="backToDateStep()">
        {{ 'common.back' | translate }}
      </sz-button>
      <sz-button variant="primary" [fullWidth]="true" (click)="done()">
        {{ 'common.datePicker.done' | translate }}
      </sz-button>
    }
  </div>
</sz-bottom-sheet>
